import { isLanguage, type Language } from '@/shared/lib/i18n'

export const allowedMessageLinkDomains = [
    typeof location !== 'undefined' ? location.hostname : '',
    'taonga.zendesk.com',
    'legal.volka.com',
    'support.taongafarm.com',
].filter((domain) => domain !== '')

export function isMessageContainsExternalLinks(message: string): boolean {
    return message.split(' ').some(isExternalLink)
}

export function isExternalLink(link: string): boolean {
    if (!looksLikeURL(link)) {
        return false
    }

    const url = parseURL(link)
    if (!url) {
        return false
    }

    if (url.protocol !== 'https:') {
        // consider non-https links as external
        return true
    }

    if (!isExternalURL(url)) {
        return false
    }

    return true
}

export function isAllowedLink(link: string): boolean {
    if (!looksLikeURL(link)) {
        return false
    }

    const url = parseURL(link)
    if (!url) {
        return false
    }

    // only https links are allowed
    if (url.protocol !== 'https:') {
        return false
    }

    if (isExternalURL(url)) {
        return false
    }

    return true
}

function isExternalURL(url: URL): boolean {
    return !allowedMessageLinkDomains.includes(url.hostname)
}
// Most reliable and performant way to check if a string is a URL
function looksLikeURL(word: string): boolean {
    return word.startsWith('https://') || word.startsWith('http://')
}

export function parseURL(link: string): URL | null {
    try {
        return new URL(link)
    } catch {
        return null
    }
}

// returns message length in characters
export function getMessageLength(message: string) {
    return Array.from(message).length
}

export function getChannelLang(channel: string): Language | null {
    const lang = channel.replace('public:lang_', '')
    return isLanguage(lang) ? lang : null
}
